import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { useDispatch, useSelector } from 'react-redux';
import { setModalMessageOkDialogVisible } from '../Slice/DialogSlice';
import { AppDispatch, RootState } from '../Store';
import styles from './dialog.module.scss';

export default function ModalMessageOkDialog() {

    const modalMessageOkDialogVisible = useSelector((state: RootState) => state.authReducer.dialog.modalMessageOkDialogVisible);
    const dispatch = useDispatch<AppDispatch>();

    const headerContent = (
        <h3 className={styles.authDialogHeadline}>Info</h3>
    );

    return (
        <Dialog
            className={classNames(styles.authDialogContainer, 'p-dialog')}
            header={headerContent}
            //footer={footerContent}
            visible={modalMessageOkDialogVisible.visible}
            onHide={() => dispatch(setModalMessageOkDialogVisible({ visible: false, text: "" }))}
        >
            <>
                <h4>{modalMessageOkDialogVisible.text}</h4>
            </>
        </Dialog>
    )
}
